import React, { useEffect, useState } from "react";
import { useGetCouriersQuery } from '../../redux/commonRTKPersist';
import _ from "lodash"
import { Box, Typography, Chip, Button } from "@mui/material";
import SearchOffOutlinedIcon from '@mui/icons-material/SearchOffOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import { FONT, SIZE, WEIGHT } from '../../styles/foundation/typography';
import { NAVY, BORDER, SUBTLE, WHITE, PRIMARY_BLUE, SUCCESS, LIGHT_BG } from '../../styles/foundation/colors';
import { SHADOW } from '../../styles/foundation/effects';

const cardSx = { bgcolor: WHITE, border: `1px solid ${BORDER}`, borderRadius: '12px', boxShadow: SHADOW.card, p: { xs: 2, md: 2.5 } };

const RateList = ({ rateListing }) => {
    const [resultList, setResultList] = useState([]);
    const [ratesFound, setRatesFound] = useState(false);

    const { data = [] } = useGetCouriersQuery()

    useEffect(() => {
        if (rateListing && rateListing[0] && rateListing[0].message === 'Zone value not found:') {
            setRatesFound(false);
        } else {
            setRatesFound(true)
            setResultList(rateListing.slice(0, 5));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rateListing]);

    const getCourierName = (row) => {
        if (row.provider && row.provider.id) {
            const result = _.find(data, (obj) => obj.prozoId === row.provider.id)
            return result?.name;
        }
        return undefined
    }
    const getDispatchMode = (row) => {
        if (row.provider && row.provider.id) {
            const result = _.find(data, (obj) => obj.prozoId === row.provider.id)
            return result?.dispatchMode;
        }
        return undefined
    }

    return (
        <Box sx={cardSx}>
            <Typography sx={{ fontFamily: FONT, fontSize: SIZE.sm, fontWeight: WEIGHT.bold, color: NAVY }}>Carrier-wise PTL rates</Typography>
            <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE, mb: 2 }}>Sorted estimates across your allocated PTL carriers</Typography>

            {!ratesFound && (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', py: 4 }}>
                    <Box sx={{ width: 56, height: 56, borderRadius: '50%', bgcolor: LIGHT_BG, display: 'flex', alignItems: 'center', justifyContent: 'center', color: SUBTLE, mb: 1.5, '& svg': { fontSize: 28 } }}>
                        <SearchOffOutlinedIcon />
                    </Box>
                    <Typography sx={{ fontFamily: FONT, fontSize: SIZE.sm, fontWeight: WEIGHT.bold, color: NAVY }}>No rates for this route</Typography>
                    <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE, mt: 0.5 }}>We couldn&apos;t find serviceable PTL rates for these pincodes. Try a different route.</Typography>
                </Box>
            )}

            {ratesFound && resultList.map((item, index) => {
                const mode = getDispatchMode(item)
                return (
                    <Box key={index} sx={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1.5,
                        p: 1.75, mb: 1.25, border: `1px solid ${BORDER}`, borderRadius: '10px', bgcolor: WHITE,
                        transition: 'box-shadow 0.2s', '&:hover': { boxShadow: SHADOW.cardHover },
                    }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
                            <Box sx={{ width: 36, height: 36, borderRadius: '8px', bgcolor: `${PRIMARY_BLUE}12`, color: PRIMARY_BLUE, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, '& svg': { fontSize: 20 } }}>
                                <LocalShippingOutlinedIcon />
                            </Box>
                            <Box sx={{ minWidth: 0 }}>
                                <Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, fontWeight: WEIGHT.bold, color: NAVY, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{getCourierName(item) || 'Carrier'}</Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.3 }}>
                                    {mode && <Chip label={mode} size="small" sx={{ fontFamily: FONT, fontSize: '0.62rem', fontWeight: WEIGHT.semibold, height: 18 }} />}
                                    <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE }}>TAT {item.providerMaxTatDays} days</Typography>
                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{ textAlign: 'right', flexShrink: 0 }}>
                            <Typography sx={{ fontFamily: FONT, fontSize: '1.05rem', fontWeight: WEIGHT.extra, color: SUCCESS, lineHeight: 1.1 }}>₹{item.priceAfterTax}</Typography>
                            <Typography sx={{ fontFamily: FONT, fontSize: '0.62rem', color: SUBTLE }}>incl. tax</Typography>
                        </Box>
                    </Box>
                )
            })}

            {ratesFound && resultList.length === 5 && (
                <Button onClick={() => setResultList(rateListing)} sx={{ fontFamily: FONT, textTransform: 'none', color: PRIMARY_BLUE, p: 0, mt: 0.5 }}>
                    View all options
                </Button>
            )}
        </Box>
    );
};

export default RateList;
